export default __webpack_public_path__ + "static/media/menu--privilege.cac7de86.jpg";